import { useLogEntityViewOnOpen } from "lib/hooks/api/userActivity/useLogEntityView";
import { LoggedEntityType } from "lib/types/graphQLEnums";
import BidContent from "../../components/bids/bid_content/BidContent";
import BidDetailsLayout from "../../components/bids/BidDetailsLayout";
import { useBid } from "../../lib/hooks/api/bid/bids/useBid";

export default function BidPage({ id }: { id: string }) {
  const { data: bid, isLoading, isError } = useBid({ id });
  useLogEntityViewOnOpen(LoggedEntityType.Bid, id);

  return (
    <BidDetailsLayout id={id} bid={bid} isLoading={isLoading} isError={isError} sidebarWidth="35%">
      {bid && (
        <BidContent
          id={bid.id}
          name={bid.name}
          bidResponses={bid.bidResponses}
          sourceUrl={bid.notice?.url}
          value={bid.value ?? undefined}
          description={bid.description ?? undefined}
          submissionDate={bid.submissionDate ?? undefined}
          clarificationDeadline={bid.clarificationDeadline ?? undefined}
          startDate={bid.startDate ?? undefined}
          awardDate={bid.awardDate ?? undefined}
          createdAt={bid.createdAt ?? undefined}
          bidReport={bid.bidReport}
          qualificationReport={bid.qualificationReport}
          buyerActivitySummary={bid.buyerActivity}
          hasNotices={!!bid.notice}
        />
      )}
    </BidDetailsLayout>
  );
}
